import React, { useState, useEffect } from 'react';
import { getOrCreateStats, getLevelForXP, getNextLevel, getXPProgress, BADGES } from './Gamification';

function StatsCard({ user }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (user) getOrCreateStats(user.id).then(setStats);
  }, [user]);

  if (!stats) return (
    <div style={{backgroundColor:"rgba(255,255,255,0.03)",padding:"30px",borderRadius:"16px",textAlign:"center",border:"1px solid rgba(255,255,255,0.06)"}}>
      <p style={{color:"#555",fontFamily:"Inter, sans-serif"}}>Loading stats...</p>
    </div>
  );

  const level = getLevelForXP(stats.xp);
  const nextLevel = getNextLevel(stats.xp);
  const progress = getXPProgress(stats.xp);

  return (
    <div style={{
      background:"linear-gradient(135deg, rgba(233,69,96,0.1), rgba(255,107,53,0.05))",
      padding:"25px",
      borderRadius:"16px",
      border:"1px solid rgba(233,69,96,0.2)",
      fontFamily:"Inter, sans-serif"
    }}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"20px"}}>
        <div>
          <h3 style={{
            fontFamily:"Bebas Neue, sans-serif",
            fontSize:"2rem",
            margin:0,
            letterSpacing:"2px",
            background:"linear-gradient(135deg, #e94560, #ff6b35)",
            WebkitBackgroundClip:"text",
            WebkitTextFillColor:"transparent"
          }}>{level.name}</h3>
          <p style={{color:"#666",margin:"4px 0 0 0",fontSize:"0.85rem",letterSpacing:"1px",textTransform:"uppercase"}}>Level {level.level}</p>
        </div>
        <div style={{textAlign:"right"}}>
          <p style={{color:"white",margin:0,fontSize:"1.5rem",fontWeight:"700"}}>{stats.xp} <span style={{color:"#e94560",fontSize:"1rem"}}>XP</span></p>
          <p style={{color:"#ff6b35",margin:"4px 0 0 0",fontSize:"0.9rem"}}>🔥 {stats.streak} day streak</p>
        </div>
      </div>

      <div style={{marginBottom:"25px"}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:"8px"}}>
          <span style={{color:"#555",fontSize:"0.8rem",textTransform:"uppercase",letterSpacing:"1px"}}>Progress to {nextLevel ? nextLevel.name : "Max Level"}</span>
          <span style={{color:"#666",fontSize:"0.8rem"}}>{progress}%</span>
        </div>
        <div style={{backgroundColor:"rgba(255,255,255,0.05)",borderRadius:"10px",height:"8px",overflow:"hidden"}}>
          <div style={{
            background:"linear-gradient(135deg, #e94560, #ff6b35)",
            borderRadius:"10px",
            height:"8px",
            width:progress + "%",
            transition:"width 0.8s ease",
            boxShadow:"0 0 10px rgba(233,69,96,0.5)"
          }}></div>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"12px",marginBottom:"20px"}}>
        {[
          { value: stats.total_uploads, label: "Videos" },
          { value: stats.streak, label: "Streak" },
          { value: stats.badges?.length || 0, label: "Badges" }
        ].map(stat => (
          <div key={stat.label} style={{
            background:"rgba(0,0,0,0.3)",
            padding:"15px",
            borderRadius:"12px",
            textAlign:"center",
            border:"1px solid rgba(255,255,255,0.05)"
          }}>
            <p style={{color:"white",margin:0,fontSize:"1.5rem",fontWeight:"700"}}>{stat.value}</p>
            <p style={{color:"#555",margin:"4px 0 0 0",fontSize:"0.75rem",textTransform:"uppercase",letterSpacing:"1px"}}>{stat.label}</p>
          </div>
        ))}
      </div>

      {stats.badges && stats.badges.length > 0 && (
        <div>
          <p style={{color:"#444",marginBottom:"10px",fontSize:"0.8rem",textTransform:"uppercase",letterSpacing:"1px"}}>Badges Earned</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:"8px"}}>
            {stats.badges.map(badgeId => {
              const badge = BADGES[badgeId];
              if (!badge) return null;
              return (
                <div key={badgeId} style={{
                  background:"rgba(233,69,96,0.1)",
                  border:"1px solid rgba(233,69,96,0.2)",
                  padding:"6px 14px",
                  borderRadius:"20px",
                  display:"flex",
                  alignItems:"center",
                  gap:"6px"
                }}>
                  <span style={{fontSize:"1rem"}}>{badge.emoji}</span>
                  <span style={{color:"#ccc",fontSize:"0.8rem",fontWeight:"500"}}>{badge.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default StatsCard;
